import { configureStore } from "@reduxjs/toolkit";
import AccountSlice from "../slice/AccountSlice";
import AuthSlice from "../slice/AuthSlice";
import ConfigMenuSlice from "../slice/ConfigMenuSlice";
import DealSlice from "../slice/DealSlice";
import NewsSlice from "../slice/NewsSlice";
import PopUpSlice from "../slice/PopUpSlice";
import StoreSlice from "../slice/StoreSlice";
import BannerSlice from "../slice/BannerSlice";
import statisticsSlice from "../slice/statisticsSlice";
import SurveySlice from "../slice/SurveySlice";
import SpamSlice from "../slice/SpamSlice";
import ChatBkavProSlice from "../slice/ChatBkavProSlice";
import GroupNotificationSlice from "../slice/GroupNotificationSlice";
import TemplatesMessageSlice from "../slice/TemplatesMessage";

const store = configureStore({
  reducer: {
    auth: AuthSlice.reducer,
    news: NewsSlice.reducer,
    pup: PopUpSlice.reducer,
    account: AccountSlice.reducer,
    storePro: StoreSlice.reducer,
    deal: DealSlice.reducer,
    menu: ConfigMenuSlice.reducer,
    banner: BannerSlice.reducer,
    statistics: statisticsSlice.reducer,
    survey: SurveySlice.reducer,
    spam: SpamSlice.reducer,
    chatBkavPro: ChatBkavProSlice.reducer,
    groupNotification: GroupNotificationSlice.reducer,
    templatesMessage: TemplatesMessageSlice.reducer,
  },
});

export default store;
